import React from "react";
import { useNavigate } from "react-router-dom";
import * as S from "./logoutModal.style";
import Modal from "..";
import { Button } from "../../../atoms/Buttons";
import { logout } from "../../../../lib/authFunctions";
import { useSetRecoilState } from "recoil";
import { userInfoSelector } from "../../../../states/user";

type LogoutModalType = {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const LogoutModal = ({ setIsModal }: LogoutModalType) => {
  const navigate = useNavigate();
  const setUserInfo = useSetRecoilState(userInfoSelector);
  return (
    <Modal title="계정 로그아웃" titlePosition="center" size="md">
      <S.LogoutModalLayout>
        <span>
          사용 중인 계정에서 <br /> 로그아웃 하시겠습니까?
        </span>
        <S.ButtonBox>
          <div className="small">
            <Button
              type="button"
              size="full"
              color="transparentGray"
              label="취소"
              onClick={() => setIsModal(false)}
            />
          </div>
          <Button
            type="button"
            size="full"
            color="primary"
            label="확인"
            onClick={() => {
              setUserInfo(null);

              // f7router 걷어내면서 로그아웃 로직 수정 필요
              logout();
              navigate("/");
            }}
          />
        </S.ButtonBox>
      </S.LogoutModalLayout>
    </Modal>
  );
};

export default LogoutModal;
